import * as http from "./http";
import {i18n} from "../translations/i18n";

export function getCardsFromResponse(subsections) {
    let cards = []
    for (let subsection of subsections) {
        let card = getCardFromSubsection(subsection)
        cards.push(card)
    }
    return cards
}
export function getCardsFromResponseNew(subsections,filterword) {
    let cards = []
    for (let subsection of subsections) {
        let card = getCardFromSubsection(subsection)
        cards.push(card)

        let cnt = 0
        if(filterword !== '') {
            for(let attachment of subsection.attachmentLinks) {
                if(filterAttachment(attachment,filterword)) {
                    let attachmentCard= getCardFromAttachment(attachment)
                    cards.push(attachmentCard)
                    cnt++
                }
            }

            if(cnt > 0){
                let index = (cards.length-cnt)
                cards[index-1].openAttachmentLink = true;
            }
        }

    }

    return cards
}

export function filterAttachment(attachment,filterword) {
    let keyword = filterword.toLowerCase();
    if (attachment.name.toLowerCase().includes(keyword)) {
        return true;
    }
    if (attachment.statuteTitle.toLowerCase().includes(keyword)) {
        return true;
    }
    if (attachment.sectionTitle.toLowerCase().includes(keyword)) {
        return true;
    }
    if (attachment.sectionSubTitle.toLowerCase().includes(keyword)) {
        return true;
    }
    if (attachment.requirement.toLowerCase().includes(keyword)) {
        return true;
    }
    if (attachment.justification.toLowerCase().includes(keyword)) {
        return true;
    }
    if (attachment.guidance.toLowerCase().includes(keyword)) {
        return true;
    }
    return false;
}

export function getCardFromSubsection(subsection) {
    let card = {
        statuteTitle: '',
        chapterTitle: '',
        subsectionTitle: subsection.sectionTitle,
        subsectionName: subsection.name,
        subsectionTitleCombined: `${subsection.sectionTitle}, ${subsection.name}`,
        chapterTitleReversed: subsection.chapterTitleReversed, // e.g. chapter 1 General provisions
        sectionTitleReversed: subsection.sectionTitleReversed, // e.g. section 1 Purpose of the Act
        sectionNameReversed: subsection.nameReversed, // e.g. subsection 1
        subsectionType: subsection.type,
        subsection: subsection.subsection,
        justification: subsection.justification,
        guidance: subsection.guidance,
        provisions: subsection.provisions,
        authorizations: subsection.authorizations,
        decreeLinks: subsection.decreeLinks,
        regulationLinks: subsection.regulationLinks,
        attachmentLinks: subsection.attachmentLinks,
        statuteIndex: subsection.statuteIndex,
        chapterIndex: subsection.chapterIndex,
        sectionIndex: subsection.sectionIndex,
        subsectionIndex: subsection.ordinal,
        justificationVisible: subsection.justificationVisible,
        guidanceVisible: subsection.guidanceVisible,
        key: subsection.journalArticleId,
        hiddenGuidanceHeadingIndices: subsection.hiddenGuidanceHeadingIndices,
        openAttachmentLink: true
    }
    if (subsection.hasOwnProperty('statuteTitle') && subsection.statuteTitle !== '') {
        card.statuteTitle = subsection.statuteTitle
    }
    if (subsection.hasOwnProperty('chapterTitle') && subsection.chapterTitle !== '') {
        card.chapterTitle = subsection.chapterTitle
        card.title = `${card.statuteTitle}, ${card.chapterTitle}, ${card.subsectionTitleCombined}`
    } else {
        card.title = `${card.statuteTitle}, ${card.subsectionTitleCombined}`
    }

    return card
}

export function getCardFromAttachment(attachment) {
    let card = {
        statuteTitle: attachment.name,
        chapterTitle: attachment.statuteTitle,
        subsectionTitle: attachment.sectionSubTitle,
        subsectionName: '',
        subsectionTitleCombined: '',
        chapterTitleReversed: '', // e.g. chapter 1 General provisions
        sectionTitleReversed: '', // e.g. section 1 Purpose of the Act
        sectionNameReversed: '', // e.g. subsection 1
        subsectionType: 'attachment',
        subsection:  attachment.requirement,
        justification: attachment.justification,
        guidance: attachment.guidance,
        provisions: attachment.provisions,
        authorizations: attachment.authorizations,
        decreeLinks: '',
        regulationLinks: '',
        attachmentLinks: '',
        statuteIndex: attachment.journalArticleId,
        chapterIndex: '',
        sectionIndex: '',
        subsectionIndex: '',
        justificationVisible: attachment.justificationVisible,
        guidanceVisible: attachment.guidanceVisible,
        key: attachment.journalArticleId,
        hiddenGuidanceHeadingIndices: attachment.hiddenGuidanceHeadingIndices
    }
    if (attachment.hasOwnProperty('chapterTitle') && attachment.chapterTitle !== '') {
        card.chapterTitle = attachment.chapterTitle
        card.title = `${card.statuteTitle}, ${card.chapterTitle}, ${card.subsectionTitleCombined}`
    } else {
        card.title = `${card.statuteTitle}, ${card.subsectionTitleCombined}`
    }

    return card
}


export function isSameCard(card1, card2) {
    const result =
        (card1.statuteIndex === card2.statuteIndex) &&
        (card1.chapterIndex === card2.chapterIndex) &&
        (card1.sectionIndex === card2.sectionIndex) &&
        (card1.subsectionIndex === card2.subsectionIndex) &&
        (card1.subsectionTitleCombined === card2.subsectionTitleCombined)
    return result
}

export function getStorableBookmarks(bookmarks, name = '') {
    let storableBookmarks = {
        entries: [],
        name: name
    }
    for (let bookmark of bookmarks) {
        const storableBookmark = (({ statuteIndex, chapterIndex, sectionIndex, subsectionIndex, justificationVisible, guidanceVisible, hiddenGuidanceHeadingIndices }) =>
            ({ statuteIndex, chapterIndex, sectionIndex, subsectionIndex, justificationVisible, guidanceVisible, hiddenGuidanceHeadingIndices }))(bookmark);
        storableBookmarks.entries.push(storableBookmark)
    }
    return storableBookmarks
}

export function getInt(value) {
    let int = parseInt(value)
    if (isNaN(int)) {
        return 0
    }
    return int
}

export function fetchSubsection(store, cardIndices, index, component, callback) {
    http.get('/get-subsection', store.state.portletId, cardIndices)
        .then(response => {
            const card = getCardFromSubsection(response.data.subsection);
            const type = card.subsectionType
            const payload = {
                card,
                index,
                type
            }
            callback(payload)
            component.$nextTick(() => {
                let cardElement = document.getElementById(`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}`)
                if (cardElement) {
                    cardElement.scrollIntoView()
                }
            })
        })
        .catch(error => {
            component.error = true
            store.dispatch('setErrorMessages', { hasErrors: true, data: { type: 'cards', code: '', text: i18n.t('sammio.errors.common_error') } })
        })

}

export function fetchAttachment(store, classPK, index, component, callback) {
    http.get('/get-attachment', store.state.portletId, classPK)
        .then(response => {

            const card = getCardFromAttachment(response.data.attachment)
            const type = card.subsectionType

            const payload = {
                card,
                index,
                type
            }
            callback(payload)
            component.$nextTick(() => {
                let cardElement = document.getElementById(`card-${card.statuteIndex}---`)
                if (cardElement) {
                    cardElement.scrollIntoView()
                }
            })
        })
        .catch(error => {
            component.error = true
            store.dispatch('setErrorMessages', {
                hasErrors: true,
                data: {type: 'cards', code: '', text: i18n.t('sammio.errors.common_error')}
            })
        })
}

export function arrayMove(array, fromIndex, toIndex) {
    let modifiedArray = array;
    let element = modifiedArray[fromIndex];
    modifiedArray.splice(fromIndex, 1);
    modifiedArray.splice(toIndex, 0, element);
    return modifiedArray;
}
